export default async (to, from, next) => {
    const token = _.get(to, 'query.newsletter', false);

    if (token) {
        await axios.post('/newsletter-subscriptions/subscribe', {token})
    }
    next();
}
